<template>
    <div class="w-full h-full">
        <ErrorModal
            v-if="showErrorModal"
            @return="showErrorModal=false"
            title="Internet connection error"
            message="It appears you're not connected to the internet. Please check your connection and try again."
        />
        <SuccessModal
            v-if="showSuccessModal"
            @return="showSuccessModal=false;getKeys()"
            title="Copy & store your API Key (This key will not be shown again)"
            :message=" newKey "
        />
        <FormModal
            v-if="showFormModal"
            @cancel="showFormModal=false"
            @confirm="createAPIKey()"
            title="Create key"
            subtitle="Create an API key"
            :valid="createAPIKeyRequest.apiKeyName != ''"
            submitButtonText="Create Key"
        >
            <CustomInput v-model="createAPIKeyRequest.apiKeyName" type="text" label="API Key name"  />
        </FormModal>
        <Header
            title="API Keys"
            icon="KeySquare"
        />
        <WhiteBox
            title="Your keys"
            subText=""
        >
        <template v-slot:buttons>
                <CustomButton id="createContract" small text="Create key" icon="Plus" type="action" @click="showFormModal=true" />
            </template>
            <template v-slot:content>
                <EasyDataTable
                    :headers="headersTable1"
                    :items="apiKeys"
                    :loading="loading"
                    v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="true"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-createdOn="apiKeys">
                        <div class="py-1">
                            {{niceDateTime(apiKeys.createdOn)}}
                        </div>
                    </template>
                    <template #item-active="apiKeys">
                        <StatusPill
                            v-if="apiKeys.active"
                            text="Active"
                            colour="green"
                        />
                        <StatusPill
                            v-else
                            text="Deactivated"
                            colour="yellow"
                        />
                    </template>
                    <template #item-action="retailers">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small v-if="!retailers.active" text="Activate" icon="Check" type="action"
                            :requiresConfirmation="true"
                            confrimationModalTitle="Activate your key"
                            confrimationModalMessage="Please confirm if you want to activate this API key"
                            confrimationModalButtonText="Activate"
                          
                            @confirmClick="activateKey(retailers.id)" />
                            <CustomButton small v-else text="Deactivate" icon="X" type="warning"
                            :requiresConfirmation="true"
                            confrimationModalTitle="Deactivate your key"
                            confrimationModalMessage="Please confirm if you want to deactivate this API key"
                            confrimationModalButtonText="Deactivate"
                            
                            @confirmClick="deactivate(retailers.id)" />
                            <CustomButton small :requiresConfirmation="true"
                            confrimationModalTitle="Delete your key"
                            confrimationModalMessage="Please confirm if you want to delete this API key" 
                            confrimationModalButtonText="Delete"
                            text="" icon="Trash2" type="warning" @confirmClick="deleteKey(retailers.id)" />
                            
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";

import WhiteBox from "@/components/WhiteBox.vue";
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import FormModal from "@/components/modals/FormModal.vue";
import { DateTime } from 'luxon';
import StatusPill from "@/components/StatusPill.vue";

export default {
	name: "manage-publsihers",
	components: {
        Header,
        WhiteBox,
        CustomInput,
		CustomButton,
        ErrorModal,
        SuccessModal,
        FormModal,
        StatusPill
	},
	props:{
    },

	data() {
		return {

            newKey:undefined,

            createAPIKeyRequest:{
                apiKeyName:""
            },
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading:true,
            headersTable1:[
                { text: "Name", value: "apiName" },
                { text: "Created on", value: "createdOn"}, 
                { text: "Status", value:"active"} ,        
                { text: "Action", value: "action"},
                
            ],
            apiKeys:[

            ],
        }
	},
	created(){
        this.getKeys()

	},
	methods: {
        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
		},
        async createAPIKey(){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/api-key`, {
					method: "POST",
                    body:JSON.stringify(this.createAPIKeyRequest),
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                    this.showSuccessModal = true
                    this.showFormModal = false
					var object = await response.json()
                    this.newKey = object.apiKeyToken

				}
				
			} catch (error) {
				return;
			}
        },

        async activateKey(id){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/api-key/${id}/re-activate`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                   this.getKeys()

				}
				
			} catch (error) {
				return;
			}
        },

        async deactivate(id){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/api-key/${id}/deactivate`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                   this.getKeys()

				}
				
			} catch (error) {
				return;
			}
        },

        async deleteKey(id){
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/api-key/${id}`, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                   this.getKeys()

				}
				
			} catch (error) {
				return;
			}
        },

        async getKeys(){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')

                this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/api-key`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.apiKeys = object  

                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

	},
	computed: {

	},
    mounted() {
        document.title = "Dashboard | API Keys";
    },
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getRetailers(val.page-1,val.rowsPerPage)
                }
    }
	}
}
</script>